/* tslint:disable */
/* eslint-disable */
/**
 * Xerjoff.Agenti.API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface OrdineDTO
 */
export interface OrdineDTO {
    /**
     * 
     * @type {number}
     * @memberof OrdineDTO
     */
    idOrdine?: number;
    /**
     * 
     * @type {string}
     * @memberof OrdineDTO
     */
    idTipoDocumento?: string | null;
    /**
     * 
     * @type {string}
     * @memberof OrdineDTO
     */
    tipoDocumento?: string | null;
    /**
     * 
     * @type {string}
     * @memberof OrdineDTO
     */
    numero?: string | null;
    /**
     * 
     * @type {string}
     * @memberof OrdineDTO
     */
    note?: string | null;
    /**
     * 
     * @type {Date}
     * @memberof OrdineDTO
     */
    data?: Date;
    /**
     * 
     * @type {Date}
     * @memberof OrdineDTO
     */
    dataConsegna?: Date;
    /**
     * 
     * @type {string}
     * @memberof OrdineDTO
     */
    idCliente?: string | null;
    /**
     * 
     * @type {string}
     * @memberof OrdineDTO
     */
    idDeposito?: string | null;
    /**
     * 
     * @type {string}
     * @memberof OrdineDTO
     */
    ragioneSociale?: string | null;
    /**
     * 
     * @type {string}
     * @memberof OrdineDTO
     */
    nomeDeposito?: string | null;
    /**
     * 
     * @type {number}
     * @memberof OrdineDTO
     */
    totaleDocumento?: number;
    /**
     * 
     * @type {boolean}
     * @memberof OrdineDTO
     */
    isSigned?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof OrdineDTO
     */
    allowSign?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof OrdineDTO
     */
    documentoEvaso?: boolean;
}

/**
 * Check if a given object implements the OrdineDTO interface.
 */
export function instanceOfOrdineDTO(value: object): value is OrdineDTO {
    return true;
}

export function OrdineDTOFromJSON(json: any): OrdineDTO {
    return OrdineDTOFromJSONTyped(json, false);
}

export function OrdineDTOFromJSONTyped(json: any, ignoreDiscriminator: boolean): OrdineDTO {
    if (json == null) {
        return json;
    }
    return {
        
        'idOrdine': json['idOrdine'] == null ? undefined : json['idOrdine'],
        'idTipoDocumento': json['idTipoDocumento'] == null ? undefined : json['idTipoDocumento'],
        'tipoDocumento': json['tipoDocumento'] == null ? undefined : json['tipoDocumento'],
        'numero': json['numero'] == null ? undefined : json['numero'],
        'note': json['note'] == null ? undefined : json['note'],
        'data': json['data'] == null ? undefined : (new Date(json['data'])),
        'dataConsegna': json['dataConsegna'] == null ? undefined : (new Date(json['dataConsegna'])),
        'idCliente': json['idCliente'] == null ? undefined : json['idCliente'],
        'idDeposito': json['idDeposito'] == null ? undefined : json['idDeposito'],
        'ragioneSociale': json['ragioneSociale'] == null ? undefined : json['ragioneSociale'],
        'nomeDeposito': json['nomeDeposito'] == null ? undefined : json['nomeDeposito'],
        'totaleDocumento': json['totaleDocumento'] == null ? undefined : json['totaleDocumento'],
        'isSigned': json['isSigned'] == null ? undefined : json['isSigned'],
        'allowSign': json['allowSign'] == null ? undefined : json['allowSign'],
        'documentoEvaso': json['documentoEvaso'] == null ? undefined : json['documentoEvaso'],
    };
}

  export function OrdineDTOToJSON(json: any): OrdineDTO {
      return OrdineDTOToJSONTyped(json, false);
  }

  export function OrdineDTOToJSONTyped(value?: OrdineDTO | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'idOrdine': value['idOrdine'],
        'idTipoDocumento': value['idTipoDocumento'],
        'tipoDocumento': value['tipoDocumento'],
        'numero': value['numero'],
        'note': value['note'],
        'data': value['data'] == null ? undefined : ((value['data']).toISOString()),
        'dataConsegna': value['dataConsegna'] == null ? undefined : ((value['dataConsegna']).toISOString()),
        'idCliente': value['idCliente'],
        'idDeposito': value['idDeposito'],
        'ragioneSociale': value['ragioneSociale'],
        'nomeDeposito': value['nomeDeposito'],
        'totaleDocumento': value['totaleDocumento'],
        'isSigned': value['isSigned'],
        'allowSign': value['allowSign'],
        'documentoEvaso': value['documentoEvaso'],
    };
}

